import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";

import axios from "axios";

import { AES, enc } from "crypto-js";
import { API_URL } from "../config";
import "./pricebook.css";

import { Link, useNavigate } from "react-router-dom";

import Header from "../Header";
import Footer from "../Footer";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { AiFillDiff } from "react-icons/ai";
import { FaPencilAlt, FaTrashAlt, FaPlus } from "react-icons/fa";
import RecentItems from "../recentItems/RecentItems";

const Createpricebooklist = () => {
  const [isLoading, setLoading] = useState(false);
  const [pricebookViews, setpricebookViews] = useState([]);
  const [isOptionsLoaded, setIsOptionsLoaded] = useState(false);
  const [selectedView, setSelectedView] = useState("all");
  const [selectedViewId, setSelectedViewId] = useState("");

  const [requestDatatype, setRequestDataType] = useState("recentmodifier");

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // Function to handle sorting logic
  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: columnKey, direction });
    sortTableData(columnKey, direction);
  };

  // Function to sort table data
  const sortTableData = (columnKey, direction) => {
    const sortedData = [...allTableData].sort((a, b) => {
      if (a[columnKey] < b[columnKey]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[columnKey] > b[columnKey]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllTableData(sortedData); // Make sure you update your table data state
  };
  const [allTableData, setAllTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columns, setColumns] = useState([]);

  const [modifiedEntriesLabel, setModifiedEntriesLabel] =
    useState("recently_created");

  const navigate = useNavigate();

  const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
  const encryptedAccessToken = localStorage.getItem("access_token");
  const decryptedAccessToken = encryptedAccessToken
    ? AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8)
    : null;

  // Function To Handle Recent Modifiers //

  const handleRandomDropdownChange = (e) => {
    const modifiedEntry = e.target.value;

    setModifiedEntriesLabel(modifiedEntry);

    setRequestDataType("recentmodifier");
  };

  // Function To Handle Page Change //

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Function To Handle Rows Per Change //

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };




  const [excludedFields, setExcludedFields] = useState([
    "id",



  ]);
  const [linkFields, setLinkFields] = useState({
    pricebook_code: { id: "id", link: "/pricebook/pricebook-details/" },



  });

  const renderTableRowsData = (data, type) => {
    switch (type) {
      case "headers":
        return data.map((col, index) => {
          if (!excludedFields.includes(col.field)) {
            return (
              <TableCell sx={{ width: 200 }} key={index}>
                {col.headerName}
              </TableCell>
            );
          }
          return null;
        });
  
      case "rows":
        return data.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((col, colIndex) => {
              if (!excludedFields.includes(col.field)) {
                const cellValue = row[col.field];
                return (
                  <TableCell sx={{ width: 200 }} key={colIndex}>
                    {linkFields.hasOwnProperty(col.field) ? (
                      <Link
                        to={`${linkFields[col.field].link}${
                          row[linkFields[col.field].id]
                        }`}
                      >
                        {formatNumberIfNeeded(cellValue)}
                      </Link>
                    ) : (
                      formatNumberIfNeeded(cellValue)
                    )}
                  </TableCell>
                );
              }
              return null;
            })}
          </TableRow>
        ));
  
      default:
        return null;
    }
  };
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
// const formatNumber = (number) => {
//     return new Intl.NumberFormat("en-US", options).format(number);
// };
const formatHeaderName = (key) => {
  // Handle the special case for 'actual_HBA'
  if (key === 'actual_HBA') {
    return 'Actual HBA';
  }

  // Replace underscores with spaces and format the string
  const replaced = key
    .replace(/_/g, " ")               // Replace underscores with spaces
    .replace(/([a-z])(\d)/gi, "$1 $2") // Add a space between letters and digits
    .toLowerCase();                    // Convert to lowercase for consistency

  // Capitalize the first letter of each word
  return replaced.replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatNumber = (value) => {
  // Check if the value is a year (likely between 1000 and 9999) and return it without decimals
  if (typeof value === 'number' && value >= 1000 && value <= 9999) {
    return value;
  }
  
  // Otherwise, return the number with two decimal places
  return typeof value === 'number' ? value.toFixed(2) : value;
};

const formatNumberIfNeeded = (value) => {
  return formatNumber(value);
};

  // Formatting Table Header Data //
  // const formatHeaderName = (key) => {
  //   // Handle the special case for actual_HBA
  //   if (key === 'actual_HBA') {
  //     return 'Actual HBA';
  //   }
    
  //   // General formatting logic for other keys
  //   const replaced = key.replace(/_/g, " ").toLowerCase();
  //   return replaced.replace(/\b\w/g, (char) => char.toUpperCase());
  // };

  const getColumnsData = (data) => {
    //desired order

   const desiredOrder = [
    'price_book_name',
    'pricebook_code',    
    'month',
    'year',
    'actual_HBA',    
    'actual_GCNEWC_for_the_month',
    'applicable_GCNEWC_for_the_month'
];


    // Get the keys from the data
    const dataKeys = Object.keys(data[0] || {});

    const columnsData = desiredOrder

      .filter((key) => dataKeys.includes(key))

      .map((key) => ({
        field: key,
        headerName: formatHeaderName(key),
      }));

    const remainingColumns = dataKeys

      .filter((key) => !desiredOrder.includes(key))

      .map((key) => ({
        field: key,
        headerName: formatHeaderName(key),
      }));

    return [...columnsData, ...remainingColumns];
  };

  // Function To Fetch Created Views //
  const fetchpricebooks = async () => {
    try {
      setLoading(true);

      const createViewResponse = await axios.get(
        `${API_URL}get/all/pricebook_createview`
      );

      if (createViewResponse.status === 200) {
        const viewData = createViewResponse.data.pricebook_createview;

        console.log(createViewResponse.data, "viewData");
        setpricebookViews(viewData);

        setLoading(false);

        setIsOptionsLoaded(true);
      }
    } catch (err) {
      console.log("An Error Occurred", err);
    }
  };



  const handleViewChange = (e) => {
    const { value, selectedIndex } = e.target;

    const selectedOptionId = e.target.options[selectedIndex].id;

    setSelectedViewId(selectedOptionId);

    setSelectedView(value);

    setRequestDataType("viewmodifier");

    sessionStorage.setItem("priceBookView", value);
    sessionStorage.setItem("priceBookViewId", selectedOptionId);
  };




  useEffect(() => {

    fetchpricebooks()

    const priceBookViewName = sessionStorage.getItem("priceBookView");

    const priceBookViewNameId = sessionStorage.getItem("priceBookViewId");

    const priceBookViewEdit = sessionStorage.getItem("priceBookViewEdit");
    const ispriceBookView = sessionStorage.getItem("ispriceBookView")

    setSelectedView(priceBookViewName)

    setSelectedViewId(priceBookViewNameId)

    if (priceBookViewEdit && priceBookViewEdit === "true" && priceBookViewName && priceBookViewNameId) {

      setRequestDataType("viewmodifier")

    } else if (ispriceBookView && ispriceBookView === "true" && priceBookViewName && priceBookViewNameId) {

      setRequestDataType("viewmodifier")

    } else {

      setRequestDataType("recentmodifier")

      setModifiedEntriesLabel("recently_created")

    }

    sessionStorage.removeItem("priceBookViewEdit");
    sessionStorage.removeItem("ispriceBookView")

  }, [])
  // Fetching View Based Data //

  const fetchViewData = async () => {
    try {
      setLoading(true);

      const URL = `${API_URL}get/pricebook/view`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${decryptedAccessToken}`,
          "Content-Type": "application/json",
        },

        params: {
          page: page + 1,
          page_size: rowsPerPage,
          view_name: selectedView,
        },
      });
console.log("****",response)
      if (response.status === 200) {
        const data = response.data.pricebook || [];

        if (data.length > 0) {
          setAllTableData(data);

          setTotalRecords(response.data.total || 0);

          const columnData = getColumnsData(data);

          setColumns(columnData);
        } else {
          setAllTableData([]);

          setTotalRecords(0);

          setColumns([]);
        }
      }
    } catch (err) {
      console.log("An Error Occurred While Retriving View Data", err);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getModifiedEntries = async () => {
    setLoading(true);

    const URL = `${API_URL}get/all/pricebook/new`;

    try {
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${decryptedAccessToken}`,
          "Content-Type": "application/json",
        },

        params: {
          random_dropdown_option: modifiedEntriesLabel,
          page: page + 1,
          page_size: rowsPerPage,
        },
      });
      console.log(response)
      if (response.status === 200) {
        const data = response.data.pricebook || [];

        if (data.length > 0) {
          setAllTableData(data);

          setTotalRecords(response.data.total);

          const columnData = getColumnsData(data);

          setColumns(columnData);
        } else {
          setAllTableData([]);

          setTotalRecords(0);

          setColumns([]);
        }
      }
    } catch (err) {
      console.log("An Error Occurred While Getting Modified Entries");
    } finally {
      setLoading(false);
    }
  };

  const navigateViewEdit = (e) => {
    e.preventDefault();

    sessionStorage.setItem("priceBookViewEdit", true);

    // /price-type/edit-view/:id
    navigate(`/pricebook/editview/${selectedViewId}`);
  };

  const navigateCreateView = (e) => {
    e.preventDefault();

    sessionStorage.setItem("priceBookViewEdit", true);

    navigate(`/pricebook/create-view`);
  };

  const navigateViewDelete = () => {};

  //  set page to 0 whenever request data type changes //
  useEffect(() => {
    setPage(0);
  }, [requestDatatype]);

  useEffect(() => {
    requestDatatype === "recentmodifier" && getModifiedEntries();
  }, [modifiedEntriesLabel, page, rowsPerPage]);

  // Fetch Selected View //

  useEffect(() => {
    requestDatatype === "viewmodifier" && fetchViewData();
  }, [selectedView, page, rowsPerPage]);

  //// accounts add

  ///// account end





 

  
  return (
    <>
      <Header />

      <div className="dashboard-container">
        <div className="recent-items">
          <h2>Recent Items</h2>
          {/* /pricebook/add-pricebook */}
         <RecentItems/>
        </div>

        <div className="accounts">
          <div className="accounts-header">
            <h2>Pricebook</h2>

            <div className="header-actions">
              <Button variant="outlined" color="error">
                <Link
                  to="/pricebook/add-pricebook"
                  style={{ textDecoration: "none", color: "red" }}
                >
                  <i className="fe fe-download-cloud me-2"></i>
                  <FaPlus /> Add Pricebook
                </Link>
              </Button>
            </div>
          </div>

          <div className="accounts-content">
            <div className="view-controls">
              <div className="view_label">
                <a>View:</a>
              </div>

              <div className="select-container">
                <select value={selectedView} onChange={handleViewChange}>
                  <option>Select a view</option>

                  {pricebookViews.length > 0 ? (
                    pricebookViews.map((option) => (
                      <option
                        key={option.id}
                        id={option.id}
                        value={option.unique_name}
                      >
                        {option.view_name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No Data Available</option>
                  )}
                </select>
              </div>

              <div className="button-container">
                <button onClick={fetchViewData}>Go</button>
              </div>

              <div className="view_actions">
                <span className="rwood_view_edit" onClick={navigateViewEdit}>
                  Edit
                </span>{" "}
                |{" "}
                <span className="rwood_view_edit" onClick={navigateViewDelete}>
                  Delete
                </span>{" "}
                |{" "}
                <span className="rwood_view_edit" onClick={navigateCreateView}>
                  Create New View
                </span>
              </div>
            </div>

            <div className="recent-accounts">
              <div className="recemt_contract_content">
                <div className="account-search">
                  <p>Recent Pricebooks</p>

                  <div className="select-modifier-container">
                    <select onChange={handleRandomDropdownChange}>
                      <option value="recently_created">Recently Created</option>
                      <option value="recently_modified">
                        Recently Modified
                      </option>
                      <option value="recently_viewed">Recently Viewed</option>
                    </select>
                  </div>
                </div>

                <div className="data_table">

                {!isLoading ? (
                    allTableData.length > 0 ? (
                      <TableContainer component={Paper}>
                      <Table
                        sx={{
                          tableLayout: "fixed", // Ensures fixed width for all columns
                          width: "100%",        // Ensures the table spans the full width
                        }}
                        size="small"
                        aria-label="a dense table"
                        className="prices"
                      >
                        <TableHead sx={{ background: "#f7f7f7" }}>
                          <TableRow>
                            {columns.map((col, index) =>
                              col.field !== "id" ? (
                                <TableCell
                                sx={{
                                  width: col.field === "pricebook_code" ? "20%" : "14.28%", // Adjust width of specific columns
                                  cursor: "pointer",
                                }}
                                key={index}
                                onClick={() => handleSort(col.field)}
                              >
                                {col.headerName}
                                {sortConfig.key === col.field && (
                                  <span>{sortConfig.direction === "asc" ? " 🔼" : " 🔽"}</span>
                                )}
                              </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>
                    
                        <TableBody>
                          {renderTableRowsData(allTableData, "rows")}
                        </TableBody>
                      </Table>
                    
                      <TablePagination
                        component="div"
                        count={totalRecords}
                        page={page}
                        onPageChange={handlePageChange}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />
                    </TableContainer>
                    
                    ) : (
                      <div className="contract_data_status">
                        <h3>No Data Available</h3>
                      </div>
                    )
                  ) : (
                    <div className="rwood_spinner">
                      <img src="../../../images/loader.svg" alt="spinner" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};


export default Createpricebooklist;
